<template>
    <div>
        <el-form :model="formData" ref="ruleForm" :rules="rules" label-position="left" label-width="80px" size="default">
            <div class="table-container">
                <h2 align="center">发货申请单</h2>
                <table class="table-layout">
                    <tbody>
                        <tr>
                            <td class="table-cell" colspan="2">公司名称</td>
                            <td class="table-cell" colspan="2">
                                <template>
                                    <el-select v-if="!showInput" style="width: 60%" v-model="formData.companyName" placeholder="请选择">
                                        <el-option
                                                v-for="item in customerList"
                                                :key="item.customerName"
                                                :label="item.customerName"
                                                :value="item.customerName">
                                        </el-option>
                                    </el-select>
                                    <input type="text" v-if="showInput" v-model="formData.companyName" style="width: 60%" class="text-input">
                                    <el-button plain @click="showInput=!showInput">{{showInput?'选择':'输入'}}</el-button>
                                </template>
                            </td>
                            <td class="table-cell" colspan="2">业务员</td>
                            <td class="table-cell" colspan="2">
                                <input type="text" v-model="formData.salesMan"  class="text-input">
                            </td>
                        </tr>
                        <tr>
                            <td class="table-cell" colspan="2">申请原因</td>
                            <td class="table-cell" colspan="2">
                                <input type="text" v-model="formData.applyCause" class="text-input">
                            </td>
                            <td class="table-cell" colspan="2">使用设备及描述</td>
                            <td class="table-cell" colspan="2">
                                <input type="text" v-model="formData.useDevice" class="text-input">
                            </td>
                        </tr>
                        <tr>
                            <td class="table-cell" colspan="8">申请内容</td>
                        </tr>
                        <tr>
                            <td class="table-cell" style="height: 70px !important">运营商</td>
                            <td class="table-cell">卡类型</td>
                            <td class="table-cell" colspan="2">套餐内容(注明配套餐出货或用户充值)/地区</td>
                            <td class="table-cell">数量(PCS)</td>
                            <!--<td class="table-cell">单位</td>-->
                            <td class="table-cell">单价(元)</td>
                            <td class="table-cell">总金额(元)</td>
                            <td class="table-cell">操作</td>
                        </tr>
                        <tr v-for="(content, index) in formData.contentList" :key="index">
                            <td class="table-radio" style="height: 70px !important">
                                <template>
                                    <el-radio v-model="content.operatorName" label="0">中国移动</el-radio>
                                    <el-radio v-model="content.operatorName" label="1">中国联通</el-radio>
                                    <el-radio v-model="content.operatorName" label="2">中国电信</el-radio>
                                    <el-radio v-model="content.operatorName" label="3">国际</el-radio>
                                </template>
                            </td>
                            <td class="table-checkbox">
                                <template>
                                    <el-checkbox-group v-model="content.cardList">
                                        <el-checkbox label="插拔卡三切"></el-checkbox>
                                        <el-checkbox label="贴片卡5*6"></el-checkbox>
                                        <el-checkbox label="贴片卡2*2"></el-checkbox>
                                        <el-checkbox label="定向"></el-checkbox>
                                        <el-checkbox label="eSIM"></el-checkbox>
                                        <el-checkbox label="vSIM"></el-checkbox>
                                        <el-checkbox label="通用"></el-checkbox>
                                    </el-checkbox-group>
                                </template>
                            </td>
                            <td class="table-cell" colspan="2">
                                <input type="text" v-model="content.packageContent" class="text-input">
                            </td>
                            <td class="table-cell">
                                <input type="text" v-model.number="content.quantity" class="text-input">
                            </td>
                            <!--<td class="table-cell">
                                <input type="text" v-model="content.units" class="text-input">
                            </td>-->
                            <td class="table-cell">
                                <input type="text" v-model="content.unitPrice" class="text-input">
                            </td>
                            <td class="table-cell">
                                <input type="text" v-model="content.grossAmount" class="text-input">
                            </td>
                            <td class="table-cell">
                                <button @click="removeContent(index)">删除</button>
                            </td>
                        </tr>

                        <tr>
                            <td class="table-cell" colspan="2">运输方式</td>
                            <td class="table-cell" colspan="2">
                                <template>
                                    <el-radio v-model="formData.modeOfTransport" label="0">自提</el-radio>
                                    <el-radio v-model="formData.modeOfTransport" label="1">送货</el-radio>
                                    <el-radio v-model="formData.modeOfTransport" label="2">快递寄付</el-radio>
                                    <el-radio v-model="formData.modeOfTransport" label="3" style="margin-left:-28px">快递到付</el-radio>
                                </template>
                            </td>
                            <td class="table-cell">要求发货日期</td>
                            <td class="table-cell" colspan="3">
                                <el-date-picker :picker-options="pickerOptions" v-model="formData.deliveryDate" type="date" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-cell" colspan="2">收货地址</td>
                            <td class="table-cell" colspan="6">
                                <input type="text" v-model="formData.shippingAddress" class="text-input">
                            </td>
                        </tr>
                        <tr>
                            <td class="table-cell" colspan="2">收货人</td>
                            <td class="table-cell" colspan="2">
                                <input type="text" v-model="formData.consignee" class="text-input">
                            </td>
                            <td class="table-cell">收货人电话</td>
                            <td class="table-cell" colspan="3">
                                <input type="text" v-model="formData.receivingPhone" class="text-input">
                            </td>
                        </tr>
                        <tr>
                            <td class="table-cell" colspan="2">是否付款</td>
                            <td class="table-cell" colspan="2">
                                <template>
                                    <p>
                                        <el-radio v-model="formData.whetherToPay"  label="1">是</el-radio>
                                        <el-radio v-model="formData.whetherToPay"  label="0">否</el-radio>
                                    </p>
                                    <p>
                                        <el-date-picker :picker-options="pickerOptions" v-model="formData.toPayDate"  type="date" format="yyyy-MM-dd" placeholder="预计付款时间:"></el-date-picker>
                                    </p>
                                </template>
                            </td>
                            <td class="table-cell">付款方式</td>
                            <td class="table-cell" colspan="3">
                                <template>
                                    <el-radio v-model="formData.payMode" label="0">对公转账</el-radio>
                                    <el-radio v-model="formData.payMode" label="1">微信</el-radio>
                                    <el-radio v-model="formData.payMode" label="2">支付宝</el-radio>
                                    <el-radio v-model="formData.payMode" label="3">测试</el-radio>
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-cell" colspan="2">支付凭证或申请说明（截图）
                            </td>
                            <td class="table-cell" colspan="6" style="height: 100px !important">
                                <el-upload class="avatar-uploader" :action="url" accept=".jpg,.png" :show-file-list="false" :on-success="handlePayVoucherImgSuccess" :before-upload="beforeAvatarUpload">
                                    <img v-if="formData.payVoucher" :src="formData.payVoucher" class="avatar">
                                    <i v-if="!formData.payVoucher" class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                            </td>
                        </tr>
                        <tr>
                            <td class="table-cell" colspan="2">备注</td>
                            <td class="table-cell" colspan="6">
                                <input type="text" v-model="formData.remark" class="text-input" onkeydown="if(event.keyCode==13){return false;}">
                            </td>
                        </tr>
                    </tbody>
                </table>
                <el-button @click="addRow" class="add-button" type="success" plain>添加行</el-button>
            </div>
        </el-form>
        <div style="padding-bottom: 50px">
            <el-button @click="submitForm" size="mini" class="save" type="primary">保存</el-button>
            <el-button @click="submitAndFlow" type="primary" size="mini" >提交</el-button>
        </div>
    </div>
</template>

<script>
    import {findShipmentRequestById, updateShipment, loginUserCustomerList,submitAndFlowShipment} from "@/api/api.js"; //查询发货申请详情
    import webSocketService from '@/utils/WebSocketService';
    export default {
        name: "shipmentRequestUpdate",
        components: {},
        props: {},
        data() {
            return {
                url: "cms/file/upload/shipmentRequest",
                showInput: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < (Date.now() - 24 * 60 * 60 * 1000);
                    }
                },
                customerList: [],
                formData: {
                    id: undefined,
                    companyName: undefined,
                    salesMan: undefined,
                    applyCause: undefined,
                    useDevice: undefined,
                    modeOfTransport: undefined,
                    deliveryDate: undefined,
                    toPayDate: undefined,
                    shippingAddress: undefined,
                    consignee: undefined,
                    receivingPhone: undefined,
                    whetherToPay: undefined,
                    payMode: undefined,
                    payVoucher: undefined,
                    remark: undefined,
                    contentList: [{
                        id: undefined,
                        operatorName: undefined,
                        //   cardType: undefined,
                        cardList: [],
                        packageContent: undefined,
                        quantity: 0,
                        units: undefined,
                        unitPrice: undefined,
                        grossAmount: undefined,
                        shipmentRequestId: undefined
                    },]
                },
                content: {
                    operatorName: '',
                    cardList: ['插拔卡三切', '贴片卡2*2', '贴片卡5*6', '定向', 'eSIM', 'vSIM'],
                    packageContent: '',
                    quantity: 0,
                    units: "",
                    unitPrice: "",
                    grossAmount: ""
                },
                rules: {
                    companyName: [
                        {required: true, message: "购货公司名称不能为空", trigger: "blur"},
                    ],
                    applyCause: [
                        {required: true, message: "申请原因不能为空", trigger: "blur"}
                    ],
                    useDevice: [
                        {required: true, message: "使用设备及场景描述不能为空", trigger: "blur"}
                    ],
                    shippingAddress: [
                        {required: true, message: "收货地址不能为空", trigger: "blur"}
                    ],
                    consignee: [
                        {required: true, message: "收货人不能为空", trigger: "blur"}
                    ],
                    receivingPhone: [
                        {
                            required: true,
                            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                            message: "请输入正确的收货人电话",
                            trigger: "blur"
                        }
                    ]
                }
            }
        },
        computed: {},
        watch: {
            '$route': {
                handler: function (to, from) {
                    if (to.name == "shipmentRequestUpdate" && (this.formData.id != to.query.id)) {
                        this.getShipmentDetail();
                        this.loginUserCustomers();
                    }
                },
                // 深度观察监听
                deep: true,
            },
        },
        created() {},
        mounted() {
            this.getShipmentDetail();
            this.loginUserCustomers();
        },
        methods: {
            submitWebSocketMessage() {
                //payload
                const message = {
                    content: "submit",
                    timestamp: Date.now(),
                };
                webSocketService.sendToTopic('/topic/shipment', message);
            },
            handleTimezoneConversion(dt) {
                // 转换为UTC时间
                let utcDate = new Date(dt.getTime() - (dt.getTimezoneOffset() * 60000));
                return utcDate;
            },
            loginUserCustomers() {
                loginUserCustomerList().then(res => {
                    if (res.data.code == 200) {
                        this.customerList = res.data.data;
                    }
                })
            },
            submitForm() {
                if (!this.formData.companyName) {
                    this.$message.error("公司名称不能为空");
                    return
                }
                if (this.formData.deliveryDate && this.formData.deliveryDate instanceof Date) {
                    this.formData.deliveryDate = this.handleTimezoneConversion(this.formData.deliveryDate);
                }
                if (this.formData.toPayDate && this.formData.toPayDate instanceof Date) {
                    this.formData.toPayDate = this.handleTimezoneConversion(this.formData.toPayDate);
                }
                this.$refs["ruleForm"].validate(valid => {
                    if (valid) {
                        updateShipment(this.formData).then(res => {
                            if (res.data.code == 200) {
                                this.$notify({
                                    title: "成功",
                                    message: "编辑发货申请成功",
                                    type: "success",
                                    duration: 1500
                                });
                                this.$store.dispatch('tagsView/delView', this.$route);
                                this.$router.push("/shipment/shipmentRequest");
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }
                });
            },
            isValidMobileNumber(phoneNumber) {
                // 定义正则表达式
                const regex = /^1[3-9]\d{9}$/;
                // 使用正则表达式测试手机号
                return regex.test(phoneNumber);
            },
            submitAndFlow() {
                if (!this.formData.companyName) {
                    this.$message.error("公司名称不能为空");
                    return
                }
                if (!this.formData.applyCause) {
                    this.$message.error("申请原因不能为空");
                    return
                }
                if (!this.formData.useDevice) {
                    this.$message.error("使用设备及场景描述不能为空");
                    return
                }
                if (!this.formData.modeOfTransport) {
                    this.$message.error("运输方式不能为空");
                    return
                }
                if (!this.formData.deliveryDate) {
                    this.$message.error("要求发货日期不能为空");
                    return
                }
                if (!this.formData.consignee) {
                    this.$message.error("收货人不能为空");
                    return
                }
                if (this.formData.modeOfTransport!='0' && this.formData.modeOfTransport!='1') {
                    if (!this.formData.shippingAddress) {
                        this.$message.error("非自提/送货，收货地址不能为空");
                        return
                    }
                    if (!this.formData.receivingPhone) {
                        this.$message.error("非自提/送货，收货人电话不能为空");
                        return
                    }
                    if (!this.isValidMobileNumber(this.formData.receivingPhone)) {
                        this.$message.error("非自提/送货，收货人电话格式不正确");
                        return
                    }
                }
                if (!this.checkPayVoucher()) {
                    this.$message.error("已付款：必须选择付款方式，上传支付凭证（非测试）；未付款：必须填写预付款时间和上传申请说明");
                    return
                }
                if (!this.formData.contentList) {
                    this.$message.error("明细不能为空");
                    return
                }
                let filteredArray = this.formData.contentList.filter(function(item) {
                    return item.operatorName !== null && item.operatorName !== undefined && item.operatorName !== ''
                        && item.packageContent !== null && item.packageContent !== undefined && item.packageContent !== ''
                        && item.cardList !== null && item.cardList.length > 0
                        && item.unitPrice !== null && item.unitPrice !== undefined
                        && item.grossAmount !== null && item.grossAmount !== undefined
                        && item.quantity !== null && item.quantity !== undefined ;
                });
                if (filteredArray.length<=0) {
                    this.$message.error("明细不能为空");
                    return
                } else {
                    this.formData.contentList = filteredArray;
                }
                if (this.formData.deliveryDate && this.formData.deliveryDate instanceof Date) {
                    this.formData.deliveryDate = this.handleTimezoneConversion(this.formData.deliveryDate);
                }
                if (this.formData.toPayDate && this.formData.toPayDate instanceof Date) {
                    this.formData.toPayDate = this.handleTimezoneConversion(this.formData.toPayDate);
                }
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        submitAndFlowShipment(this.formData).then((res) => {
                            if (res.data.code == 200) {
                                this.$notify({
                                    title: "成功",
                                    message: "提交成功",
                                    type: "success",
                                    duration: 1500,
                                });
                                this.$store.dispatch('tagsView/delView', this.$route);
                                this.$router.push("/shipment/shipmentRequest");

                                this.submitWebSocketMessage()
                            } else {
                                this.$message.error(res.data.message);
                            }
                        });
                    }
                });
            },
            resetForm() {
                this.$refs['ruleForm'].resetFields()
            },
            addRow() {
                this.formData.contentList.push({
                    operatorName: '',
                    cardList: [],
                    packageContent: '',
                    quantity: 0,
                    units: "",
                    unitPrice: "",
                    grossAmount: ""
                });

            },
            removeContent(index) {
                if(this.formData.contentList.length >= 2) {
                    this.formData.contentList.splice(index, 1);
                }
            },
            checkPayVoucher() {
                if (this.formData.payMode == '3') {
                    return true;
                } else {
                    if (this.formData.whetherToPay == '0' && !this.formData.toPayDate){
                        return false;
                    }
                    // if (this.formData.whetherToPay == '1' && !this.formData.payVoucher) {
                    //     return false;
                    // }
                    if(!this.formData.payVoucher){
                        return false;
                    }
                    return true
                }
            },
            // 上传支付凭证图片
            handlePayVoucherImgSuccess(res, file) {
                if (res.code == 200) {
                    this.formData.payVoucher = "/cms/" + res.data.url;
                }
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            //查询发货申请详情
            getShipmentDetail() {
                let id = this.$route.query && this.$route.query.id;
                findShipmentRequestById({id: id}).then(res => {
                    this.formData = res.data.data
                    this.formData.contentList.forEach(m => {
                        m.cardType = undefined
                    })
                    this.content = this.formData.contentList
                })
            }
        }
    }

</script>

<style lang="scss">
    .el-input-number.full-width-input,
    .el-cascader.full-width-input {
        width: 100% !important;
    }

    .el-form-item--medium {
        .el-radio {
            line-height: 36px !important;
        }

        .el-rate {
            margin-top: 8px;
        }
    }

    .el-form-item--small {
        .el-radio {
            line-height: 32px !important;
        }

        .el-rate {
            margin-top: 6px;
        }
    }

    .el-form-item--mini {
        .el-radio {
            line-height: 28px !important;
        }

        .el-rate {
            margin-top: 4px;
        }
    }

    .clear-fix:before,
    .clear-fix:after {
        display: table;
        content: '';
    }

    .clear-fix:after {
        clear: both;
    }

    .float-right {
        float: right;
    }
</style>

<style lang="scss" scoped>
    div.table-container {
        margin-top: 50px;
        margin-left: 220px;
        max-width: 1200px;
        padding: 20px;
        border-radius: 5px;
        border: 1px solid black;

        table.table-layout {
            table-layout: fixed;
            border-collapse: collapse;
            width: 1080px;

            td.table-cell {
                display: table-cell;
                height: 36px;
                border: 1px solid black;
                text-align: center;
            }
        }
    }

    .table-checkbox,
    .table-radio {
        display: table-cell;
        border: 1px solid black;
        text-align: left;
    }

    .add-button {
        margin-top: -340px;
        margin-right: -10px;
        float: right;
        position: relative;
    }

    .save {
        margin-top: 50px;
        margin-left: 750px;
        position: relative;
    }

    .text-input {
        width: 100%;
        height: 100%;
        padding: 5px;
        border: 1px #ccc;
        border-radius: 4px;
        box-sizing: border-box;
        text-align: center;
    }

    .text-input-left {
        width: 100%;
        height: 100%;
        padding: 5px;
        border: 1px #ccc;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .radio-input {
        vertical-align: middle;
        margin-top: -2px;
        margin-bottom: 1px;
    }

    .avatar-uploader {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        width: 138px;
        height: 138px;
    }

    .avatar-uploader:hover {
        border-color: #409eff;
    }

    .svg-avatar-uploader-icon {
        font-size: 28px;
        width: 60px;
        height: 60px;
        line-height: 18px;
        text-align: center;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 138px;
        height: 138px;
        line-height: 138px;
        text-align: center;
    }

    .avatar {
        width: 138px;
        height: 138px;
        display: block;
    }
</style>